var parser = require('./lib/parser')

module.exports = {
  parse: function(input) {
    return parser.parse(input.toString())
  }
}
